import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Sprout, X } from "lucide-react";
import { api } from "@/lib/api";

const KEY = "rr_week_recap_dismissed";

export function WeekRecapLine() {
  const [recap, setRecap] = useState(null);
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    api.get("/recap/week").then((r) => {
      setRecap(r.data);
      setHidden(localStorage.getItem(KEY) === r.data.week);
    }).catch(() => {});
  }, []);
  if (!recap || !recap.show || hidden) return null;
  const dismiss = () => { localStorage.setItem(KEY, recap.week); setHidden(true); };
  return (
    <motion.div initial={{ opacity: 0, y: -6 }} animate={{ opacity: 1, y: 0 }} data-testid="week-recap-line"
      className="flex items-center gap-3 rounded-2xl border border-emerald-200 bg-emerald-50/70 px-4 py-3">
      <Sprout className="w-4 h-4 text-emerald-700 shrink-0" />
      <p className="flex-1 text-sm text-stone-800" data-testid="week-recap-text">{recap.line}</p>
      <button type="button" onClick={dismiss} aria-label="Dismiss" data-testid="week-recap-dismiss"
        className="p-1 rounded-lg text-stone-400 hover:text-stone-700 hover:bg-emerald-100 transition">
        <X className="w-4 h-4" />
      </button>
    </motion.div>
  );
}
